import {Component, inject, Input} from '@angular/core';
import {FormFieldComponent, IczFormGroup} from '@icz/angular-form-elements';
import {TranslateService} from '@ngx-translate/core';
import {DocumentForm} from '|api/commons';
import {SectionComponent, TooltipDirective} from '@icz/angular-essentials';
import {NgTemplateOutlet} from '@angular/common';
import {formatPaperComponentCounts, OWN_DOCUMENT_OBJECT_CLASSES, RECEIVED_DOCUMENT_OBJECT_CLASSES} from '|shared';
import {DocumentAllowableObjectClass} from '|api/document';

@Component({
  selector: 'icz-essl-component-counts',
  templateUrl: './essl-component-counts.component.html',
  styleUrls: ['./essl-component-counts.component.scss'],
  imports: [SectionComponent, NgTemplateOutlet, FormFieldComponent, TooltipDirective]
})
export class EsslComponentCountsComponent {

  private translateService = inject(TranslateService);

  @Input({required: true}) form!: IczFormGroup; // expected is an OwnDocument or ReceivedDocument form which have fields for component counts
  @Input() boxed = false;

  get complexPaperComponentsCounts(): string {
    return formatPaperComponentCounts(
      {
        mainPaperComponentSheetCount: this.form.get('mainPaperComponentSheetCount')!.value,
        paperComponentSheetEnclosureCount: this.form.get('paperComponentSheetEnclosureCount')!.value,
        paperComponentSheetCount: this.form.get('paperComponentSheetCount')!.value,
        paperComponentVolumeEnclosureCount: this.form.get('paperComponentVolumeEnclosureCount')!.value,
      },
      this.translateService,
    );
  }

  get nonPaperAnalogComponentsSum() {
    return this.form.get('nonPaperComponentCount')!.value;
  }

  get consignmentDigitalComponentsCount() {
    return this.form.get('consignmentDigitalComponentsCount')!.value;
  }

  get digitalComponentCount() {
    return (this.form.get('digitalComponentCount')!.value) as number;
  }

  get totalDigitalComponentsCount() {
    if (!isNil(this.digitalComponentCount) && !isNil(this.consignmentDigitalComponentsCount)) {
      return this.digitalComponentCount + this.consignmentDigitalComponentsCount;
    }
    else {
      return '';
    }
  }

  get isOwnDocument(): boolean {
    return OWN_DOCUMENT_OBJECT_CLASSES.includes(this.objectClass);
  }

  get isReceivedDocument(): boolean {
    return RECEIVED_DOCUMENT_OBJECT_CLASSES.includes(this.objectClass);
  }

  get isAnalogDocument(): boolean {
    return this.documentForm === DocumentForm.ANALOG;
  }

  get isDigitalDocument(): boolean {
    return this.documentForm === DocumentForm.DIGITAL;
  }

  get isHybridDocument(): boolean {
    return this.documentForm === DocumentForm.HYBRID;
  }

  private get objectClass(): DocumentAllowableObjectClass {
    return this.form.get('objectClass')?.value;
  }

  private get documentForm(): DocumentForm {
    return this.form.get('documentForm')?.value;
  }

}
